module.exports = __webpack_public_path__ + "static/img/地图.8477a3c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newImage/地图.png
// module id = EGQv
// module chunks = 3